import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import EditButton from "../../components/Buttons/EditButton";
import ErrorMsg from "../../components/ErrorMsg";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useEditDesignationMutation } from "../../services/appln";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@material-ui/icons/Edit";

interface FormData {
  name: string;
  abbreviation: string;
}

interface Props {
  id: string;
  initialValues: any;
}

export default function EditDesignation(props: Props) {
  console.log("EditDesignation, props:", props);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [editDesignation, editDesignationParams] = useEditDesignationMutation();

  const iv: FormData = {
    name: props.initialValues.name,
    abbreviation: props.initialValues.abbreviation,
  };

  console.log("EditDesignation, editDesignationParams:", editDesignationParams);
  React.useEffect(() => {
    if (editDesignationParams.isSuccess) {
      handleClose();
    }
  }, [editDesignationParams]);

  return (
    <div>
      <IconButton color="secondary" onClick={handleClickOpen}>
        <EditIcon />
      </IconButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {strings.editDesignation}
        </DialogTitle>
        {editDesignationParams.isError && (
          <ErrorMsg msg={strings.failedToEditDesignation} />
        )}
        {editDesignationParams.isLoading && <ProgressIndicator />}
        <DialogContent>
          <Formik
            initialValues={iv}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              if (!values.name) {
                errors.name = strings.nameMandatory;
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              editDesignation({ id: props.id, body: values });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="name"
                        name="name"
                        label={strings.name}
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        margin="normal"
                        id="abbreviation"
                        name="abbreviation"
                        label={strings.abbreviation}
                        value={values.abbreviation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.abbreviation && Boolean(errors.abbreviation)
                        }
                        helperText={touched.abbreviation && errors.abbreviation}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ButtonGroup>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.save}
                        </Button>
                        <Button variant="contained" onClick={handleClose}>
                          {strings.cancel}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
